import adoptziLogo from "../assets/svgs/adoptzi_logo.svg";
import { SLIDE_ACCESSORY, SLIDE_ALL, SLIDE_FOOD, SLIDE_GROOMING, SLIDE_HOSPITAL, SLIDE_VET } from "./slideVetsTypes";

export const vetSlidingData = [
  {
    key: "anuncio1",
    name: "¿Quiéres estar en este espacio?",
    description: "Será un gusto poder ponernos en contacto contigo. Puedes dar click sobre este espacio para comunicarte con el equipo de Adoptzi.",
    phone: "+502 42149355",
    location: "",
    image: "svgs/adoptzi_logo.svg",
    pos: 100.0,
    social: {
      facebook: "https://www.facebook.com/adoptzi",
      instagram: "https://www.instagram.com/adoptzi/",
      website: "https://adoptzi.com",
      phone: "tel://+50242149355",
    },
    linkTo: "https://wa.link/8skz44",
    // Alguna idea que si tiene esta flag, salga hasta arriba de la busqueda
    recommended: true,
    // Alguna idea que sirva para ordernar los resultados (algun tipo de subasta)
    order: 0,
    // Alguna idea que sirva para filtrar por tipo
    type: []
  },
  {
    key: "anuncio2",
    name: "Pet-ID",
    description: "Registro Nacional de Mascotas de la República de Guatemala. Bríndale a tu mascota bienestar y protección para toda la vida.",
    phone: "",
    location: "",
    image: "images/partners/petid_logo.png",
    pos: 100.0,
    social: {
      facebook: "https://www.facebook.com/petid.gt",
      instagram: "https://www.instagram.com/petid.gt/",
      website: "https://www.petid.com.gt",
      phone: "",
    },
    linkTo: 'https://www.petid.com.gt',
    recommended: false,
    order: 0,
    type: [SLIDE_ACCESSORY]
  },
  {
    key: "anuncio3",
    name: "Guaufood",
    description: "Somos la mejor opción de comida natural para perros. Nuestros planes quincenales y mensuales son ideales para una nutrición balanceada y un mejor cuidado de la salud de tus mascotas.",
    phone: "+502 55923596",
    location: "",
    image: "images/partners/guaufood_logo.png",
    pos: 100.0,
    social: {
      facebook: "https://www.facebook.com/guaufood",
      instagram: "https://www.instagram.com/guaufood/",
      website: "",
      phone: "",
      whatsapp: "https://api.whatsapp.com/send?phone=50255923596",
    },
    linkTo: "https://api.whatsapp.com/send?phone=50255923596",
    recommended: false,
    order: 0,
    type: [SLIDE_FOOD]
  },
];
